import { UserResponseSchema } from '@app/core/api/user';

/**
 * User state interface for NgRx store
 */
export interface UserState {
  profile: UserResponseSchema | null;
  loading: boolean;
  deletingAccount: boolean;
  deletingPersonalData: boolean;
  error: string | null;
  cacheTimestamp: number | null;
}

/**
 * Initial state for user feature
 */
export const initialUserState: UserState = {
  profile: null,
  loading: false,
  deletingAccount: false,
  deletingPersonalData: false,
  error: null,
  cacheTimestamp: null
};
